import { infoDialogBox } from '../../shared/helpers';

class SwitchController extends Controller {
  static targets = [ 'input', 'switch', 'infoBox' ]

  connect() {
    this.setSwitchText()
    this.updateInfoBox()
  }

  toggleState() {
    this.state === 'off' ? this.turnSwitchOn() : this.turnSwitchOff()
    this.updateInfoBox()
  }

  //
  // INTERNAL USE
  //

  turnSwitchOn() {
    this.state = 'on'
    this.inputValue = this.onValue
    this.setSwitchText()
  }

  turnSwitchOff() {
    this.state = 'off'
    this.inputValue = this.offValue
    this.setSwitchText()
  }

  setSwitchText() {
    this.switchTarget.innerHTML = this.state
  }

  updateInfoBox() {
    this.infoBoxTarget && (this.infoBoxTarget.innerHTML = this.getInfoContent())
  }

  getInfoContent() {
    return infoDialogBox(this.data.get(`${this.state}-info`))
  }

  //
  // GETTERS AND SETTERS
  //

  get state() {
    return this.data.get('state')
  }

  set inputValue(value) {
    this.inputTarget.value = value
  }

  set state(value) {
    this.data.set('state', value)
  }

  get onValue() {
    return this.data.get('on-value')
  }

  get offValue() {
    return this.data.get('off-value')
  }
}
export default SwitchController



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/shared/switch-controller.js